import "client-only";
import useSWR from "swr";
import { fetcher } from "src/utils/fetcher";
export default function usePaymentAccountList(params) {
  return useSWR(
    {
      path: `/api/v1/bank-infos`,
      method: "GET",
      params: {
        limit: 50,
        skip: 0,
        ...params,
      },
    },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}
